import { environment } from './../../../../../../environments/environment';
import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BackOfficeService } from '../../../../../services/backoffice.service';

@Component({
  selector: 'app-display-tests',
  standalone: false,
  templateUrl: './display-tests.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './display-tests.component.css'
})
export class DisplayTestsComponent {
  @Input() gateId: string;
  @Input() display: any;
  isLoading: boolean = false;
  displayUrls: string[] = [
    "https://parking-display.blackmoss-70f082ae.swedencentral.azurecontainerapps.io",
    "https://parking-display-test.mangocliff-b7a35cda.swedencentral.azurecontainerapps.io",
    "http://localhost:4200"
  ];
  // parkingDisplay: string = this.uris[0];

  hostPath = 'Shuttlebuss/Shuttlebuss.Service/LPR/';
  statusList = [
    { endpoint: 'TestDisplayEntry1', viewValue: 'Entry 1', url: '' },
    // { endpoint: 'TestDisplayEntry2', viewValue: 'Entry 2', url: '' },
    // { endpoint: 'TestDisplayExit1', viewValue: 'Exit 1', url: '' },
    { endpoint: 'TestDisplayExit', viewValue: 'Exit', url: '' },
    { endpoint: 'TestDisplayExitNotPaid', viewValue: 'Exit Not Paid', url: '' },
    { endpoint: 'TestDisplayRegister', viewValue: 'Register', url: '' },
    { endpoint: 'TestDisplayRegistered', viewValue: 'Registered', url: '' },
    { endpoint: 'TestDisplayDriveUpRegistered', viewValue: 'DriveUp Registered', url: '' },
    { endpoint: 'TestDisplayParkingFull', viewValue: 'Parking Full', url: '' },
    { endpoint: 'TestDisplayWrongParkingSite', viewValue: 'Wrong Parking Site', url: '' },
    { endpoint: 'TestDisplayOnEntrySubscriptionStatus', viewValue: 'On Entry Subscription Status', url: '' },
    { endpoint: 'TestDisplayOnExitSubscriptionStatus', viewValue: 'On Exit Subscription Status', url: '' },
    // { endpoint: 'TestDisplayLicensePlateNotRead', viewValue: 'License Plate Not Read', url: '' },
    // { endpoint: 'TestDisplayOnEntrySubscription', viewValue: 'On Entry Subscription ', url: '' },
    // { endpoint: 'TestDisplayOnExitSubscription', viewValue: 'On Exit Subscription ', url: '' },
    { endpoint: 'ReloadDisplay', viewValue: 'Reload Display', url: '' },
  ]
  constructor(
    private backofficeService: BackOfficeService,
    @Inject(MAT_DIALOG_DATA) public data: {
      gateId: string,
      display: any,
    },
    public dialogRef: MatDialogRef<DisplayTestsComponent>
  ) {
    this.gateId = this.data.gateId;
    this.display = this.data.display;
  }

  ngOnInit(): void {
    this.statusList.forEach(status => {
      const baseUrl = environment.IDENTITY.replace(/"/g, '');
      status.url = baseUrl + this.hostPath + status.endpoint + '?gateId=' + this.gateId;
    })
  }

  executeTest(url: any) {
    this.isLoading = true;
    this.backofficeService.executeDisplayTest(url).subscribe((result: any) => {
      this.isLoading = false;
    });
  }
}
